import { Divider } from "@mui/material";
import React from "react";
import { useAuth } from "src/allauth/auth";
import { useAppContext } from "../context/AppContext";
import AthleteMenu from "./menus/AthleteMenu";
import AuthenticatedMenu from "./menus/AuthenticatedMenu";
import CoachMenu from "./menus/CoachMenu";
import ParentMenu from "./menus/ParentMenu";
import PublicPagesMenu, { MenuProps } from "./menus/PublicPagesMenu";

const RoleBasedMenu: React.FC<MenuProps> = ({ layout = 'drawer' }) => {
    const { membership } = useAppContext();
    const auth = useAuth();

    // Get user from auth context for consistent state
    const user = auth?.data?.user;
    const isAuthenticated = auth?.meta?.is_authenticated;
    const availableRoles = membership?.roles || [];

    // If not authenticated, show anonymous menu
    if (!isAuthenticated || !user?.id) {
        return <PublicPagesMenu layout={layout} isAuthenticated={isAuthenticated} />;
    }

    // Determine which menu to show based on available roles
    // Priority: admin/agent > coach > parent > athlete
    const renderMenu = () => {
        if (availableRoles.includes('admin') || availableRoles.includes('agent')) {
            return <CoachMenu layout={layout} />;
        }
        if (availableRoles.includes('coach')) {
            return <CoachMenu layout={layout} />;
        }
        if (availableRoles.includes('parent')) {
            return <ParentMenu layout={layout} />;
        }
        if (availableRoles.includes('athlete')) {
            return <AthleteMenu layout={layout} />;
        }
        return <AuthenticatedMenu layout={layout} />;
    };

    // Add divider for drawer layout to separate from public pages
    if (layout === 'drawer') {
        return (
            <>
                <Divider sx={{ my: 1 }} />
                {renderMenu()}
                <Divider sx={{ my: 1 }} />
                <PublicPagesMenu layout={layout} isAuthenticated={isAuthenticated} />
            </>
        );
    }

    if (layout === 'footer') {
        return (
            <>
                {renderMenu()}
                <PublicPagesMenu layout={layout} isAuthenticated={isAuthenticated} />
            </>
        );
    }

    return renderMenu();
};

export default RoleBasedMenu;
